import NodeModel from 'rise-ui/models/types/node.js';

import { attr } from '@ember-data/model';

export default class HelpPageModel extends NodeModel {
  @attr('string') title;
  @attr('string') topic;
}
